import React from "react";
import "../../page_content.css";

const Awards = () => {
  return (
    <div>
      <h1 className="title">Awards & Recognitions </h1>
      <hr />
      <div className="awards-intro">
        <p>
          The institute has been awarded "A1" (Outstanding) rating by the BUREAU
          VERITAS during the Comprehensive Inspection Program (CIP) initiated by
          DG Shipping, Govt. of India. MANET Pune has also been approved by the
          Ministry of Land, Infrastructure and Transport, Government of Japan.
        </p>
        <p>
          MANET has been awarded by Devang Mehta Foundation for "Education
          Leadership Award" in 2014. It has also been awarded the "Best Maritime
          Training Institute" by ABP News Channel in 2015. During a poll carried
          out in 2014, by the Times of India, for the best Engineering Colleges
          in India, MANET was the only Maritime Institute that was part of the
          top 100 colleges in India.
        </p>
      </div>

      <div className="page-content-gallery">
        <img
          src="/assets/images/awards/ABP_News_National-Education-Award_2015.webp"
          alt="Award 1"
        />
        <img
          src="/assets/images/awards/Devang_Mehata_Education_Leadership_Award_-Certificate - C.webp"
          alt="Award 2"
        />
        <img
          src="/assets/images/awards/Devang_Mehata_Award_Reception.webp"
          alt="Award 3"
        />
      </div>
    </div>
  );
};

export default Awards;
